import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {auth} from "../actions";


class CheckoutSuccess extends Component{
  constructor(props) {
    super(props);
    this.state = {
      updated: false,
      password: '',
      confirmPassword: '',
      error: false,
      success: false,
    }
  }

  handleInputChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (event) => {
    event.preventDefault()
    if (this.state.confirmPassword === this.state.password) {
      this.props.firstPassword(this.state.password).then(
        this.setState({success: true})
      )
    } else {
      this.setState({error: true})
    }
  }


  render() {
    return(
        <div className="Checkout-top">
          <h2>Ditt abonnemang har skapats!</h2>
          {
            this.state.success
            ?
            <div>
              <p>Ditt lösenord är skapat!</p>
              <Link to="/">Gå till ditt abonnemang</Link>
            </div>
            :
            <form onSubmit={this.handleSubmit}>
              <p>Var vänlig skapa ett lösenord för ditt abonnemangskonto</p>
              {
                this.state.error
                ?
                <p>Lösenorden stämmer inte med varandra</p>
                :
                null
              }
              <label className="Account-label" htmlFor="password">
                Lösenord
              </label>
              <input type="text" name="email" defaultValue={this.props.email} hidden/>
              <input
                id="password"
                className="Account-input"
                type='password'
                name="password"
                autoComplete="new-password"
                onChange={this.handleInputChange} />
              <label className="Account-label" htmlFor="confirmPassword">
                Bekräfta Lösenord
              </label>
              <input
                id="confirmPassword"
                className="Account-input"
                type='password'
                name="confirmPassword"
                autoComplete="new-password"
                onChange={this.handleInputChange} />
              <input
                type="submit"
                value="Spara"
                className="Account-button"
                />
            </form>
          }
        </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    email: state.auth.email,
    isAuthenticated: state.auth.isAuthenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    firstPassword: (password) => {
      return dispatch(auth.firstPassword(password));
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSuccess);



// WEBPACK FOOTER //
// ./src/components/CheckoutSuccess.jsx